<template>
    <div class="productinfo-page">
        <div>
            <router-view class="" v-if="isRouterAlive"/>
        </div>
        <home-foot></home-foot>
    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot"
export default {
    name: "productinfo",
    components:{
        HomeFoot,
    },
    data() {
        return {
            isRouterAlive:true,
        };
    },
    methods:{
        reload(){
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        },
    },
    updated(){
        $('.productinfo-page').animate({ scrollTop:0 }, 600);
    },
    watch: {
        '$route' (to, from) { 
            this.reload();
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.productinfo-page{
    margin-top: 60px;
    overflow: auto;
}
.router-view{
    margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/productinfo.vue